define(function(require) {
    return {
        LAYER_ID : "GEO07E15_SECT_SPES",
        LAYER_TYPE : "POLYGON",
        LOADING_MODE : "INITIAL",
        TOKEN_REQUIRED: true,
        USE_TYPED_ARRAY : true,
        INDEX : 7,
        DATATABLE_ID : "t_GEO07E15_SECT_SPES",
        QUERY_FIELDS : ["GUID", "SECTEUR", "CD_COULR"],
        FIELDS : [
            {ID : "GUID", NAME : "GUID", DATA_TYPE : "STRING", VALUE : "{{GUID}}"},
            {ID : "SECTEUR", NAME : "Code", DATA_TYPE : "STRING", VALUE : "{{SECTEUR}}"},
            {ID : "CD_COULR", NAME : "CD_COULR", DATA_TYPE : "NUMBER", VALUE : "{{CD_COULR}}"},
        ],
        STYLES : [
            {
                ID : "0",
                VALUE : 0,
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "SOLID",
                        FILL_COLOR_1 : "rgba(135,119,105,1)",
                        STROKE_COLOR : "rgba(166,166,166,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 1
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Bold",
                    FONT_FILE_SOURCE : "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 12,
                    VISIBLE : true
                }
            }, {
                ID : "1",
                VALUE : 1,
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "SOLID",
                        FILL_COLOR_1 : "rgba(225,194,116,1)",
                        STROKE_COLOR : "rgba(166,166,166,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 1
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Bold",
                    FONT_FILE_SOURCE : "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 12,
                    VISIBLE : true
                }
            }, {
                ID : "2",
                VALUE : 2,
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "SOLID",
                        FILL_COLOR_1 : "rgba(59,73,187,1)",
                        STROKE_COLOR : "rgba(166,166,166,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 1
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Bold",
                    FONT_FILE_SOURCE : "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 12,
                    VISIBLE : true
                }
            }, {
                ID : "3",
                VALUE : 3,
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "SOLID",
                        FILL_COLOR_1 : "rgba(149,208,2,1)",
                        STROKE_COLOR : "rgba(166,166,166,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 1
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Bold",
                    FONT_FILE_SOURCE : "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 12,
                    VISIBLE : true
                }
            }, {
                ID : "4",
                VALUE : 4,
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "SOLID",
                        FILL_COLOR_1 : "rgba(239,87,79,1)",
                        STROKE_COLOR : "rgba(166,166,166,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 1,
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Bold",
                    FONT_FILE_SOURCE : "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 12,
                    VISIBLE : true
                }
            }, {
                ID : "5",
                VALUE : 5,
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "SOLID",
                        FILL_COLOR_1 : "rgba(73,222,144,1)",
                        STROKE_COLOR : "rgba(166,166,166,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 1
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Bold",
                    FONT_FILE_SOURCE : "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 12,
                    VISIBLE : true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Secteurs de prévision des effectifs scolaires",
            ALPHA : 0.5,
            FEATURE_ID_DATACOLUMN : "GUID",
            FEATURE_NAME_DATACOLUMN : "SECTEUR",
            DATATIP_DATACOLUMNS : ["SECTEUR"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["SECTEUR"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["SECTEUR"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["SECTEUR"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            STYLE_DATACOLUMN : "CD_COULR",
            LABEL_DATACOLUMN : "SECTEUR",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : true,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5,
                VISIBLE : true
            }
        }
    };
});
